class ICSManufacturersDirectory {
  constructor(root) {
    this.root = root;
    this.input = root.querySelector('[data-manufacturer-filter]');
    this.clear = root.querySelector('[data-manufacturer-clear]');
    this.items = Array.from(root.querySelectorAll('[data-manufacturer-item]'));
    this.groups = Array.from(root.querySelectorAll('[data-manufacturer-group]'));
    this.letters = Array.from(root.querySelectorAll('[data-manufacturer-letter]'));
    this.count = root.querySelector('[data-manufacturer-count]');
    this.empty = root.querySelector('[data-manufacturer-empty]');
    this.activeLetter = 'all';

    if (!this.input || !this.items.length) return;

    this.input.addEventListener('input', () => this.apply());
    this.clear?.addEventListener('click', () => this.reset());
    this.letters.forEach((button) => {
      button.addEventListener('click', () => {
        this.activeLetter = button.dataset.manufacturerLetter || 'all';
        this.letters.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        this.apply();
      });
    });
  }

  apply() {
    const query = this.input.value.trim().toLocaleLowerCase();
    let visibleCount = 0;

    this.items.forEach((item) => {
      const name = (item.dataset.manufacturerName || '').toLocaleLowerCase();
      const letter = item.dataset.manufacturerInitial || '#';
      const matchesQuery = !query || name.includes(query);
      const matchesLetter = this.activeLetter === 'all' || letter === this.activeLetter;
      const visible = matchesQuery && matchesLetter;

      item.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    this.groups.forEach((group) => {
      group.hidden = !group.querySelector('[data-manufacturer-item]:not([hidden])');
    });

    if (this.count) this.count.textContent = String(visibleCount);
    if (this.empty) this.empty.dataset.visible = String(visibleCount === 0);
  }

  reset() {
    this.input.value = '';
    this.activeLetter = 'all';
    this.letters.forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.manufacturerLetter === 'all'));
    });
    this.apply();
    this.input.focus();
  }
}

document.querySelectorAll('[data-ics-manufacturers]').forEach((root) => {
  new ICSManufacturersDirectory(root);
});

document.addEventListener('shopify:section:load', (event) => {
  const root = event.target.querySelector('[data-ics-manufacturers]');
  if (root) new ICSManufacturersDirectory(root);
});
